import {Component, OnInit, Inject, NgZone} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import * as moment from 'moment';

@Component({
    selector: 'md-kanban-form-cheque-depot-item-dialog',
    templateUrl: './md-kanban-form-cheque-depot-item-dialog.component.html',
})
export class MdKanbanFormChequeDepotItemDialogComponent implements OnInit {
    loading = false;
    itemForm = this._formBuilder.group({
        ID: [null],
        ROWID_CHEQUE: [null, Validators.required],
        NUM_CHEQUE: [null, Validators.required],
        MONTANT_CHEQUE: [0, [Validators.required, Validators.min(1)]],
        DATE_CHEQUE: [moment().format('YYYY-MM-DD'), Validators.required]
    });
    kanbanItem: any;
    startupInfos: any;
    
    constructor(
        private _formBuilder: FormBuilder,
        public dialogRef: MatDialogRef<MdKanbanFormChequeDepotItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: { kanbanItem: any, startupInfos: any, item?: any },
    ) {
        this.kanbanItem = data.kanbanItem;
        this.startupInfos = data.startupInfos;
        if (!!data.item) {
            this.itemForm.patchValue({
                ID: data.item.ID,
                ROWID_CHEQUE: data.item.ROWID_CHEQUE,
                NUM_CHEQUE: data.item.NUM_CHEQUE,
                MONTANT_CHEQUE: data.item.MONTANT_CHEQUE,
                DATE_CHEQUE: data.item.DATE_CHEQUE,
            });
        }
    }

    ngOnInit() {
    }

    dismiss() {
        this.dialogRef.close();
    }

    onSubmit() {
        if (this.itemForm.invalid) { return; }
        this.dialogRef.close(this.itemForm.value);
    }

    onChequeSelected(e: MatSelectChange) {
        const numCheque = e.value;
        const selectedCheque = this.startupInfos.CHEQUES.find(c => c.ID == numCheque);
        if (!!selectedCheque?.TEXT) {
            this.itemForm.controls.ROWID_CHEQUE.patchValue(selectedCheque.ROWID);
            this.itemForm.controls.MONTANT_CHEQUE.patchValue(selectedCheque.TEXT);
        }
    }
}